const SUPPORT_EMAIL = "support@5gvi.verizon.com";
export const ERROR_INSUFFICIENT_ACCESS = "Insufficient access level";
export const ERROR_REFRESH_TOKEN_EMPTY = "Refresh Token is empty";
export const ERROR_NETWORK = "Network error: No response from the server. Please check your internet connection.";
// This message is used when the client is ONLINE but the server is unreachable
// (e.g., DNS error, connection refused). This corresponds to ConnectionRefusedError.
export const ERROR_SERVICE_UNREACHABLE = "Service Connection Failed. We are unable to connect to the required backend service.";

// This message is reserved for when the client is truly OFFLINE.
// This corresponds to NetworkError.
export const ERROR_NETWORK_DISCONNECTED = "Connection Lost. Please check your internet connection.";
export const ERROR_API_REQUEST_FAILED = (msg) => `API Request Failed: ${msg}`;
export const ERROR_TOKEN_REFRESH_FAILED = (statusText) => `Token refresh failed: ${statusText}`;
export const ERROR_SERVER_STATUS = (status) => `Server responded with status ${status}`;

export const ERROR_TITLES = {
  NETWORK: "Connection Lost",
  SERVER: "Server Unavailable",
  DATA: "Data Loading Error",
  GENERIC: "Oops, something went wrong.",
  NETWORK_DISCONNECTED: "Connection Lost",
  SERVICE_UNREACHABLE: "Service Unreachable"
};

export const ERROR_MESSAGES = {
  NETWORK: "Please check your internet connection and try again.",
  SERVER: "We're experiencing a service outage. Please try again later.",
  DATA: "There was an issue loading the data. The content may be temporarily unavailable.",
  GENERIC: "An unexpected error occurred. Please clear your cache and cookies and try again.",
  GENERIC_EMAIL: (logId) => (
    <span>
      If the issue persists, please send an email to <strong>{SUPPORT_EMAIL}</strong> with the following Log ID: <strong>{logId}</strong>
    </span>
  ),
  ERROR: "We're working to fix the issue. Please go back and try again.",
  SERVICE_UNREACHABLE: "The connection to the backend service failed. Please try reloading the application.",
  NETWORK_DISCONNECTED: "This is likely due to loss of internet connection. Please try restarting your browser or checking your network.",
  INCIDENTS_BY_FLOOR_FETCH_FAILED: "Failed to get Critical Incidents Count for Site/Floor"
};

export const ERROR_TYPES = {
  NETWORK: "network",
  SERVER: "server",
  DATA: "data",
  CODE: "code",
  GENERIC: "generic",
  ERROR: "error",
  WARNING: "warning"
};

export const ERROR_UNKNOWN = "Unknown Error";
export const ERROR_WENT_WRONG = "Something went wrong";

export const ERROR_CODES = {
  ERR_NETWORK: "ERR_NETWORK",
  ECONNREFUSED: "ECONNREFUSED"
};

export const EXPECT_UNDEFINED = "undefined";
export const EXPECT_NULL = "null";
export const EXPECT_EMPTY = "empty";
export const EXPECT_STRING = "string";
export const EXPECT_OBJECT = "object";

export const NAMING_VALIDATION_ERROR = "Use only letters, numbers, single spaces, hyphens (-), underscores (_), or hash (#)";
